<template>
  <v-row justify="space-between" align="center" class="ma-0">
    <v-breadcrumbs :items="crumbs" divider="/"></v-breadcrumbs>
    <v-btn icon="mdi-plus" density="comfortable" @click="showModal = true" id="show-modal"></v-btn>
  </v-row>
  <v-row>
    <v-col cols="12" md="12">
      <v-card :elevation="1">
        <v-card-text>
          <v-table>
            <thead>
              <tr>
                <th class="table-heading-text">account name</th>
                <th class="table-heading-text text-center">bank</th>
                <th class="table-heading-text text-center">account type</th>
                <th class="table-heading-text text-center">balance</th>
                <th class="table-heading-text text-center">interest rate</th>
                <th class="table-heading-text text-right">annual interest</th>
              </tr>
            </thead>
            <tbody>
              <tr class="remove-bottom-border" v-for="cash_account in cash_accounts.cash_accounts" :key="cash_account.id" @click="showEditModal(cash_account )">
                <td class="table-content-text text-left"> {{ cash_account.account_name }}</td>
                <td class="table-content-text">{{ cash_account.bank }}</td>
                <td class="table-content-text">{{ cash_account.account_type }}</td>
                <td class="table-content-text">{{ cash_account.balance.toLocaleString() }}</td>
                <td class="table-content-text">{{ Number(cash_account.interest_rate).toLocaleString('en-GB', { style: 'percent', minimumFractionDigits:2 }) }}</td>
                <td class="table-content-text text-right">{{ Number(cash_account.annual_interest).toLocaleString("en", {minimumFractionDigits: 0, maximumFractionDigits: 0}) }}</td>
              </tr>
              <tr class="add-top-border">
                <td></td>
                <td></td>
                <td></td>
                <td class="table-heading-text">{{ Number(cash_accounts.total_balance).toLocaleString("en", {minimumFractionDigits: 0, maximumFractionDigits: 0}) }}</td>
                <td class="table-heading-text">{{ Number(cash_accounts.total_interest_rate).toLocaleString('en-GB', { style: 'percent', minimumFractionDigits:2 }) }}</td>
                <td class="table-heading-text text-right">{{ Number(cash_accounts.total_annual_interest).toLocaleString("en", {minimumFractionDigits: 0, maximumFractionDigits: 0}) }}</td>
              </tr>
            </tbody>
          </v-table>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>

  <!-- Modals-->
  <CashModalPopup :show="showModal" @close="showModal = false"></CashModalPopup> <!-- add a new record -->
  <CashEditModalPopup :show="showEditModalToggle" :currentRow="selectedRow" @close="showEditModalToggle = false"></CashEditModalPopup> <!-- edit a record -->

</template>

<script>
import axios from 'axios';
import CashModalPopup from './modals/CashNewModalPopup.vue';
import CashEditModalPopup from './modals/CashEditModalPopup.vue';
import { mapState, mapMutations} from 'vuex';

export default {
  components: {
    CashModalPopup,
    CashEditModalPopup
  },
  data() {
    return {
      cash_accounts: [],
      showModal: false,
      showEditModalToggle: false,
      selectedRow: {},
      dialog: false,
    };
  },
  async created() {
    this.getCashAccounts();
  },
  computed: {
    ...mapState({
      token: "token"
    }),
    crumbs() {
      return [
        {
          title: 'cash accounts',
          disabled: true,
          href: ''
        },
      ];
    },
  },
  methods: {
      ...mapMutations(["showSnackbar"]),
    showEditModal(row){
     this.selectedRow=row;
     this.showEditModalToggle = true;
    },
    async getCashAccounts(){
      try {
      const response  = await axios.get("/cashaccounts/",
      {
        headers: {
          Authorization: `Bearer ${this.token}`
        }
      });
          this.cash_accounts = response.data;
      } catch (error) {
        this.showSnackbar({ message: 'Failed to load cash accounts' });
      }
    }
  }
};
</script>


<style scoped>

table tr{
  cursor: pointer;
}

.table-heading-text{
  font-size: 1.5rem;
  font-weight: 300 !important;
}

.table-content-text{
  font-size: 1.05rem;
  font-weight: 300 !important;
}

.remove-bottom-border td{
  border-bottom: none !important;
}

.add-top-border td{
  border-top: 1px solid rgba(0, 0, 0, 0.12) !important;
}
</style>